// Copyright (c) 2025 Audere, All Rights Reserved

import { Paper, Table, TableBody, TableCell, TableRow, TableHead } from "@mui/material";
import { createStyleSheet } from "../utils/styles";
import { theme } from "../../theme";

type Column = { header: string; key: string };

const DashboardTable = ({
  columns,
  data,
}: {
  columns: Column[];
  data: Record<string, string | number>[];
}) => {
  return (
    <Paper elevation={2} sx={styles.container}>
      <Table size="small">
        <TableHead>
          <TableRow sx={styles.tableHeadRow}>
            {columns.map((col, i) => (
              <TableCell
                key={col.key}
                sx={{
                  ...styles.tableHeadCell,
                  borderRight: i < columns.length - 1 ? "1px solid white" : undefined,
                  borderTopLeftRadius: i === 0 ? "8px" : 0,
                  borderTopRightRadius: i === columns.length - 1 ? "8px" : 0,
                }}
              >
                {col?.header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((row, idx) => (
            <TableRow key={idx}>
              {columns.map((col, i) => (
                <TableCell
                  key={col.key}
                  sx={{
                    ...styles.tableBodyCell,
                    borderRight:
                      i < columns.length - 1 ? `1px solid ${theme.palette.grey[300]}` : undefined,
                  }}
                >
                  {row[col.key]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default DashboardTable;

const styles = createStyleSheet({
  container: {
    borderRadius: "4px",
    width: "100%",
  },
  tableHeadRow: {
    backgroundColor: theme.palette.primary.main,
  },
  tableHeadCell: {
    color: theme.palette.primary.contrastText,
    fontWeight: "bold",
    overflow: "hidden",
    fontSize: "16px",
  },
  tableBodyCell: {
    padding: "8px",
    fontSize: "16px",
  },
});
